<template>
    <div class="adQuizVideoPlayer">
        <video ref="videoPlayer" class="video-js" playsinline></video>
        <div @click="mouseMoveHendler" :class="'controls'+(showControls ? '' : ' hide')">
            <div class="progressBar"><span :style="'width: '+progress+'%;'"></span></div>
            <button @click="replay();btnSfx();" type="button" class="replayBtn"></button>
            <button @click="soundToggle();btnSfx();" type="button" :class="'videoSound'+(videoSound ? '' : ' off')"></button>
            <button v-if="!demo" @click="report();btnSfx();" type="button" class="report"></button>
            <button @click="$emit('eventClose');btnSfx();" type="button" class="closeVideo"></button>
            <div class="countDown">{{ countDown }}</div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
import videojs from 'video.js';
import app from '../app'
import api from '../api'

const VideoPlayer = Vue.component('video-player', {
    props: {
        adQuiz: {
            type: Object,
            default() {
                return { sources: undefined };
            }
        },
        demo: false
    },
    data() {
        return {
            player: null,
            progress: 0,
            countDown: 0,
            showControls: true,
            videoSound: false,
        }
    },
    methods:{
        btnSfx(){
            this.$store.dispatch('sound/sfx','Button');
        },

        init(){
            const $this = this;
            this.progress = this.countDown = 0;
            this.videoSound = localStorage.videoSound == "false" ? false : true;

            if(this.player != null){
                this.player.src([{
                            src: this.adQuiz.videoUrl,
                            type: 'application/x-mpegURL'
                        }]);

                this.player.currentTime(0);
                this.player.play();
            }
            else{
                this.player = videojs(this.$refs.videoPlayer, {
                        autoplay: true, 
                        controls: false, 
                        sources: [{
                            src: this.adQuiz.videoUrl,
                            type: 'application/x-mpegURL'
                        }]
                    }, 
                    function onPlayerReady() {
                        $this.mouseMoveHendler();
                    }
                );

                //this.player.on('dblclick', function() { $this.player.requestFullscreen(); });

                this.player.on('ended', function() {
                    $this.$store.dispatch('sound/pauseBg', false);
                    $this.$emit('eventEnded');
                });

                this.player.on('timeupdate', function(e){
                    $this.setProgress();
                });
            }

            $this.$store.dispatch('sound/pauseBg', true);
            $this.player.muted(!$this.videoSound);
        },

        setProgress(){
            this.progress = this.player.currentTime() / this.player.duration() * 100;
            this.countDown = Math.round(this.player.duration() - this.player.currentTime());
        },

        replay(){
            if(this.player){
                this.player.currentTime(0);
                this.player.play();
                this.$store.dispatch('sound/pauseBg', true);
            }
        },

        soundToggle(){
            this.videoSound = !this.videoSound;
            localStorage.setItem('videoSound', this.videoSound);
            this.player.muted(!this.videoSound);
        },

        mouseMoveHendler(){
            clearTimeout(this.timer);
            this.showControls = true;
            this.timer = setTimeout(() => {
                this.showControls = false;
            }, 2000);
        },

        report(){
            const $this = this;
            this.player.pause();
            this.$bvModal.msgBoxConfirm(this.$t('home.popup_report_confirm'), {
                title: 'INFO',
                size: 'sm',
                buttonSize: 'lg',
                okTitle: this.$t('base.btn_save'),
                cancelTitle: this.$t('base.btn_cancel'),
                modalClass: 'confirmModal',
                hideHeaderClose: false,
                centered: true,
            })
            .then(value => {
                if(value){
                    $this.$store.dispatch('sound/pauseBg', false);
                    $this.$emit('eventClose');
                    api.addAdQuizToBlacklist($this.adQuiz.id).then(function (response) {
                        // no actions
                    })
                    .catch(function (error) {
                        api.baseErrorHendler(error);
                    })
                }
                else
                    $this.player.play();
            })
            .catch(err => {
                $this.player.play();
            })
            .then(value => {
                $this.$store.dispatch('sound/sfx','Button');
            });
        },
    },

    mounted() {
        this.timer = null;

        this.$el.addEventListener('mousemove', () => {
            this.mouseMoveHendler();
        })

        this.$el.addEventListener('mouseleave', () => {
            clearTimeout(this.timer);
        })

        this.init();
    },

    beforeDestroy(){
        clearTimeout(this.timer);
        this.$store.dispatch('sound/pauseBg', false);

        if (this.player) {
            this.player.pause();
        }
    }
});

export default VideoPlayer
</script>